import Button from "../Button";

interface FMCSALinkProps {
  mc?: string;
  dot?: string;
  children?: React.ReactNode | React.ReactNode[];
  className?: string;
}

const FMCSALink: React.FC<FMCSALinkProps> = ({ className, mc, dot, children = "FMCSA Report" }) => {
  if (!mc && !dot) return null;

  const queryParam = mc ? "MC_MX" : "USDOT";
  const queryString = mc || dot;

  return (
    <form
      method="post"
      action="https://safer.fmcsa.dot.gov/query.asp"
      target="_blank"
      rel="noopener noreferrer"
      className="flex">
      <input name="searchtype" value="ANY" type="hidden" />
      <input name="query_type" value="queryCarrierSnapshot" type="hidden" />
      <input name="query_param" value={queryParam} type="hidden" />
      <input name="query_string" value={queryString} type="hidden" />
      <Button
        type="submit"
        variant="text"
        className={`!px-0 text-sm underline text-info desktop:text-base btn-link ${className}`}>
        {children}
      </Button>
    </form>
  );
};

export default FMCSALink;
